module.exports = __webpack_public_path__ + "img/video_fault.15547ddd.svg";